export enum FetchStatusType {
    IDLE = 'idle',
    LOADING = 'loading',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export type ErrorApi = {
    message: string
    status: number
}